import api from "./base-api"

const mcUserApi = api.injectEndpoints({
    endpoints: (build) => ({
        searchMcUserIds: build.query({
            query: ({
                sTransactionId = ""
            }) => `v2/mc/users/search?sTransactionId=${sTransactionId}`
        })
    })
})

export const {
    useSearchMcUserIdsQuery
} = mcUserApi
